const gasOrderReducer = (state = [], action) => {
  switch (action.type) {
    case 'ADICIONAR':
      if (state.find((obj) => obj.id === action.payload.id)) {
        return state;
      } else {
        return (state = [...state, action.payload]);
      }

    case 'REMOVER':
      let copyState = [...state];
      copyState.splice(action.payload, 1);
      return copyState;

    case 'FECHAR':
      let newState = [...state];
      newState[action.payload].isOpen = false;
      return newState;

    case 'EDITARCONTA':
      let accountState = [...state];

      if (JSON.stringify(action.payload.conta).length === 2) {
        accountState[action.payload.index].conta = {};
        accountState[action.payload.index].nomeOportunidade = '';
      } else {
        accountState[action.payload.index].conta = action.payload.conta;
        accountState[action.payload.index].nomeOportunidade =
          action.payload.conta.nome;
      }

      return accountState;

    case 'EDITARPRODUTOS':
      let productState = [...state];
      productState[action.payload.index] = {
        ...productState[action.payload.index],
        isFormated: true
      };
      productState[action.payload.index].produtos = action.payload.produtos;
      return productState;

    case 'EDITARCAMPOSCONTA':
      let accountFieldState = [...state];

      accountFieldState[action.payload.index].conta = {
        ...accountFieldState[action.payload.index].conta,
        [action.payload.field]: action.payload.value
      };

      return accountFieldState;

    case 'EDITARCAMPOSPEDIDODEGAS':
      let gasOrderFieldState = [...state];

      gasOrderFieldState[action.payload.index] = {
        ...gasOrderFieldState[action.payload.index],
        [action.payload.field]: action.payload.value
      };

      return gasOrderFieldState;

    default:
      return state;
  }
};

export default gasOrderReducer;
